import * as HttpService from 'services/http.service';
import { GET_CITY_DETAILS } from 'services/url.service';

export const getCityDetails = () =>
  HttpService.getWithoutAuth(GET_CITY_DETAILS);

export default getCityDetails; // TODO: Remove after add another export function or var.
